import { render } from "./AmazingPhotoEditor.vue?vue&type=template&id=1a3cca62&scoped=true"
import script from "./AmazingPhotoEditor.vue?vue&type=script&lang=js"
export * from "./AmazingPhotoEditor.vue?vue&type=script&lang=js"

import "./AmazingPhotoEditor.vue?vue&type=style&index=0&id=1a3cca62&scoped=true&lang=css"

import exportComponent from "/home/frog/Documents/vue/AeAAppDev/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3cca62"]])

export default __exports__